import type { TIssue } from './api';

// Newest wins, same tie-break the removed server-side adapter used: a source can have two
// live auth issues in turn (two verification steps failing one after another).
export const authIssueBySource = (issues: readonly TIssue[]): Map<string, TIssue> => {
  const bySource = new Map<string, TIssue>();
  for (const issue of issues) {
    if (!issue.sourceId) continue;
    const current = bySource.get(issue.sourceId);
    if (!current || new Date(issue.lastSeen) > new Date(current.lastSeen)) {
      bySource.set(issue.sourceId, issue);
    }
  }
  return bySource;
};
